"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgScreenLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M106.454 163.925a4304.984 4304.984 0 01-5.957 7.926c-1.95-2.588-3.9-5.184-5.852-7.784-7.357-9.797-14.748-19.641-22.365-29.238h0c-12.506-15.751-24.78-31.35-24.78-51.343 0-29.244 23.745-52.986 52.997-52.986 29.255 0 53.003 23.736 53.003 52.986 0 20.003-12.283 35.601-24.792 51.352-7.583 9.542-14.936 19.339-22.254 29.087z",
    stroke: props.color || "#052E40",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.497 58.5c13.801 0 25.003 11.198 25.003 24.997 0 13.795-11.208 25.003-25.003 25.003-13.799 0-24.997-11.202-24.997-25.003 0-13.79 11.208-24.997 24.997-24.997z",
    stroke: props.color || "#052E40",
    strokeWidth: 5
  }));
}

var _default = SvgScreenLocation;
exports["default"] = _default;